import { useCallback, useState } from 'react';
import moment from 'moment';
import { useSnackbar } from 'notistack';

import { getMessagesGPT, postMessageGPT } from '../../../crud/chat.crud';
import { useFormatMessage } from '../../../hooks';
import { getResponseMessage } from '../../../utils/utils';

export type TMessageGPT = {
  content: string;
  date: string;
  id: string;
  role: 'assistant' | 'user';
  error?: {
    message: string;
  };
};

export const useGetMessagesGPT = () => {
  const fm = useFormatMessage();
  const { enqueueSnackbar } = useSnackbar();
  const [loadingGPT, setLoading] = useState(false);
  const [loadingSend, setLoadingSend] = useState(false);
  const [messagesGPT, setMessages] = useState<TMessageGPT[]>([]);

  const fetchMessagesGPT = useCallback(async (user_id?: number | string) => {
    setLoading(true);
    getMessagesGPT(user_id)
      .then((res: any) => {
        setMessages(res.data.data.filter((i: TMessageGPT) => !!i && !!i?.content));
      })
      .catch(e => {
        enqueueSnackbar(`${fm('ERROR')}: ${getResponseMessage(e)}`, {
          variant: 'error',
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const sendMessage = (message: string) => {
    setLoadingSend(true);
    const data = new FormData();
    data.append('message', message);
    setMessages(state => [
      ...state,
      {
        content: message,
        id: moment().format('DD.MM.YYYY HH:mm:ss'),
        date: moment().format('DD.MM.YYYY HH:mm:ss'),
        role: 'user',
      },
    ]);
    postMessageGPT(data)
      .then((res: any) => {
        if (res.data?.data?.error?.message) {
          setLoadingSend(false);
          enqueueSnackbar(fm('CHATGPT.ERROR'), {
            variant: 'error',
          });
        } else {
          // updateMessagesGPT();
          const newMessages: TMessageGPT[] = res.data.data.choices.map((i: any) => ({
            content: i.message.content,
            id: moment().format('DD.MM.YYYY HH:mm:ss'),
            date: moment().format('DD.MM.YYYY HH:mm:ss'),
            role: 'assistant',
          }));
          setMessages(state => [...state, ...newMessages]);
        }
      })
      .catch(e => {
        if (!e?.response?.data?.message) {
          enqueueSnackbar(fm('CHATGPT.ERROR'), {
            variant: 'error',
          });
        } else {
          enqueueSnackbar(`${fm('ERROR')}: ${getResponseMessage(e)}`, {
            variant: 'error',
          });
        }
      })
      .finally(() => {
        setLoadingSend(false);
      });
  };

  const clearMessages = useCallback(() => {
    setMessages([]);
  }, []);

  return {
    fetchMessagesGPT,
    loadingGPT,
    messagesGPT,
    sendMessage,
    clearMessages,
    loadingSend,
  };
};
